<template>
  <div class="text-center mt-64">
    <h1>SERVER ERROR</h1>
    <h5>{{ $t($store.getters.configError) }}</h5>
    <h2>Please refresh the page and try again</h2>
  </div>
</template>

<script lang="ts" src="./config-error.component.ts" />
